import axios from 'axios'
export default function addFeature(config) {
  if (!config.url) {
    return Promise.reject('url is empty')
  }
  // 自动添加cancelToken
  if (typeof config.cancelExecutor === 'function') {
    config.cancelToken = new axios.CancelToken(config.cancelExecutor)
  }
  // 自动转换成form表单提交形式
  if (config.emulateJSON && /^post|put$/i.test(config.method)) {
    config.headers = Object.assign({}, config.headers, {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    })
  }
  const extraParams = {}
  // 支持jsonp
  if (/^jsonp$/i.test(config.method)) {
    config.jsonp || (config.jsonp = 'callback')
    config.jsonpCallback = '_jsonp' + Math.random().toString(36).substr(2)
    extraParams[config.jsonp] = config.jsonpCallback
  }
  config.params = Object.assign({}, config.params, extraParams)
  return config
}
